package com.example.mystybag.appCore.views

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.width
import androidx.compose.ui.unit.dp
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.pager.HorizontalPager
import androidx.compose.foundation.pager.rememberPagerState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.SideEffect
import androidx.compose.runtime.key
import androidx.compose.runtime.remember
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import com.arkivanov.decompose.extensions.compose.subscribeAsState
import dev.icerock.moko.resources.ImageResource
import dev.icerock.moko.resources.compose.painterResource
import dev.icerock.moko.resources.compose.stringResource
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DELIVERY
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_FAVORITES
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_HOME
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_PROFILE
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_DASHBOARD
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_BAGS
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_LOCATIONS
import com.example.mystybag.appCore.logic.MystyBagDigitalWalletViewModel.Companion.PAGE_MENU
import com.example.mystybag.appCore.logic.MainViewModel
import com.example.mystybag.appCore.logic.pages.DeliveryPageViewModel
import com.example.mystybag.appCore.logic.pages.FavoritesPageViewModel
import com.example.mystybag.appCore.logic.pages.HomePageViewModel
import com.example.mystybag.appCore.logic.pages.ProfilePageViewModel
import com.example.mystybag.appCore.logic.pages.DashboardViewModel
import com.example.mystybag.appCore.logic.pages.BagsViewModel
import com.example.mystybag.appCore.logic.pages.MerchantLocationsListViewModel
import com.example.mystybag.appCore.logic.pages.MenuViewModel
import com.example.mystybag.appCore.model.pages.HomeViewMode
import com.example.mystybag.appCore.views.pages.DeliveryPageView
import com.example.mystybag.appCore.views.pages.DeliveryPageWebView
import com.example.mystybag.appCore.views.pages.FavoritesPageView
import com.example.mystybag.appCore.views.pages.FavoritesPageWebView
import com.example.mystybag.appCore.views.pages.HomePageView
import com.example.mystybag.appCore.views.pages.ProfilePageView
import com.example.mystybag.appCore.views.pages.ProfilePageWebView
import com.example.mystybag.appCore.views.pages.DashboardView
import com.example.mystybag.appCore.views.pages.DashboardWebView
import com.example.mystybag.appCore.views.pages.BagsView
import com.example.mystybag.appCore.views.pages.BagsWebView
import com.example.mystybag.appCore.views.pages.MerchantLocationsListView
import com.example.mystybag.appCore.views.pages.MerchantLocationsListWebView
import com.example.mystybag.appCore.views.pages.FilterResultsBottomSheetView
import com.example.mystybag.appCore.views.pages.MenuView
import com.example.mystybag.appCore.views.pages.MenuWebView
import com.example.mystybag.appCore.logic.FilterResultsBottomSheetChild
import com.example.mystybag.appCore.logic.pages.FilterResultsBottomSheetViewModel
import com.example.mystybag.common.expected.hideWebHomeMapOverlayNow
import com.example.mystybag.common.expected.showWebHomeMapOverlayNow
import com.example.mystybag.common.extensions.Image
import com.example.mystybag.common.extensions.noRippleClickable
import com.example.mystybag.common.resources.SR
import com.example.mystybag.common.ui.components.custom.StateProgressView
import com.example.mystybag.common.ui.components.native.Texts
import com.example.mystybag.common.ui.views.BottomSheetUIView
import com.example.mystybag.common.views.CommonBottomSheetFactory
import com.example.mystybag.core.helpers.WebLocaleComposition
import com.example.mystybag.core.helpers.homeButtonImage
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.core.ui.theme.LocalTheme.p12
import com.example.mystybag.core.ui.theme.LocalTheme.p20
import com.example.mystybag.core.ui.theme.LocalTheme.p4
import com.example.mystybag.core.ui.theme.LocalTheme.p8
import com.example.mystybag.core.ui.theme.LocalTheme.p32
import com.example.mystybag.core.views.AppTheme
import com.example.mystybag.core.defines.UtilsPreferencesDefines.PREFERENCES_MERCHANT_JWT
import com.example.mystybag.core.expected.PlatformHelper
import com.example.mystybag.core.expected.rememberIsWebPortraitLayout
import com.example.mystybag.core.expected.rememberUseNativeStyleWebLayout
import com.example.mystybag.core.expected.Preferences
import com.example.mystybag.core.ui.theme.LocalTheme.p16
import com.example.mystybag.core.ui.theme.LocalTheme.p6

@Composable
fun MainView(viewModel: MainViewModel) {

    val pages       = viewModel.pages.subscribeAsState()
    val pagerState  = rememberPagerState(pageCount = { pages.value.items.size })
    val colors      = AppTheme.current.colors

    @Composable
    fun navItem(
        modifier: Modifier,
        index   : Int,
        title   : String,
        icon    : ImageResource
    ) {
        val isActive = index == pages.value.selectedIndex
        val iconColor = if (isActive) AppTheme.current.colors.onPrimaryContainer else AppTheme.current.colors.onSurfaceVariant
        val textColor = if (isActive) AppTheme.current.colors.onPrimaryContainer else AppTheme.current.colors.onSurfaceVariant
        val padColor = if (isActive) AppTheme.current.colors.primaryContainer else Color.Transparent

        Column(
            modifier = modifier
                .noRippleClickable { viewModel.selectPage(index, fromView = true) }
                .padding(vertical = p4),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(p4)
        ) {
            Box(
                modifier = Modifier
                    .background(
                        color = padColor,
                        shape = RoundedCornerShape(p32)
                    )
                    .padding(horizontal = p16, vertical = p6),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    painter     = painterResource(icon),
                    modifier    = Modifier.size(p20),
                    colorFilter = ColorFilter.tint(iconColor)
                )
            }
            Texts.LabelSmall(
                text = title,
                color = textColor
            )
        }
    }

    @Composable
    fun NavBar(modifier: Modifier = Modifier) {
        val merchantJwt = Preferences.getString(key = PREFERENCES_MERCHANT_JWT, "")
        val isMerchant = merchantJwt.isNotEmpty()
        
        Row(
            modifier = modifier.background(colors.background)
        ) {
            if (isMerchant) {
                // Merchant tabs: Dashboard, Bags, Обекти (locations), Menu (account)
                navItem(Modifier.weight(1f), PAGE_DASHBOARD, stringResource(SR.strings.home), homeButtonImage())
                navItem(Modifier.weight(1f), PAGE_BAGS, stringResource(SR.strings.bags), SRC.images.merchant_tab_bags)
                navItem(Modifier.weight(1f), PAGE_LOCATIONS, stringResource(SR.strings.objects), SRC.images.merchant_tab_locations)
                navItem(Modifier.weight(1f), PAGE_MENU, stringResource(SR.strings.menu), SRC.images.menu_menu_image)
            } else {
                // Client tabs: твоите иконки – Find, Reservations, Favorites, Account
                navItem(Modifier.weight(1f), PAGE_HOME, stringResource(SR.strings.home), SRC.images.nav_find)
                navItem(Modifier.weight(1f), PAGE_DELIVERY, stringResource(SR.strings.delivery), SRC.images.nav_reservations)
                navItem(Modifier.weight(1f), PAGE_FAVORITES, stringResource(SR.strings.favorites), SRC.images.nav_favorites)
                navItem(Modifier.weight(1f), PAGE_PROFILE, stringResource(SR.strings.menu), SRC.images.menu_menu_image)
            }
        }
    }

    BottomSheetUIView(
        viewModel                   = viewModel,
        modifier                    = Modifier.fillMaxSize(),
        windowInsets                = WindowInsets.statusBars ,
        bottomSheetFactory          = remember { {
            when (it) {
                is FilterResultsBottomSheetChild -> {
                    it.viewModel?.let { vm ->
                        FilterResultsBottomSheetView(vm as FilterResultsBottomSheetViewModel)
                    }
                }
               // is EmailConfirmationBottomSheetChild        -> EmailConfirmationBottomSheetView(it.viewModel)
                else                                        -> CommonBottomSheetFactory(it)
            }
        } }
    ) { state ->

        Box {
            LaunchedEffect(pages.value.selectedIndex) {
                if (pagerState.currentPage != pages.value.selectedIndex)
                    pagerState.scrollToPage(page = pages.value.selectedIndex)
            }

            LaunchedEffect(pagerState) {
                snapshotFlow { pagerState.currentPage }
                    .collect { page ->
                        if (page == pagerState.targetPage && pages.value.selectedIndex != page) {
                            viewModel.selectPage(page, fromView = true)
                        }
                    }
            }

            val merchantJwtForPager = Preferences.getString(key = PREFERENCES_MERCHANT_JWT, "")
            val isMerchantForPager = merchantJwtForPager.isNotEmpty()
            // На Web търговецът ползва мобилните екрани за табовете Bags/Objects/Menu; таб „Начало“
            // превключва Dashboard / DashboardWeb според ориентацията (портрет = като приложение).
            val useMobileMerchantViewsOnWeb = PlatformHelper.isWeb && isMerchantForPager
            val useNativeStyleWebLayout = rememberUseNativeStyleWebLayout()

            val pagerContent: @Composable () -> Unit = {
                HorizontalPager(
                    modifier                = Modifier.fillMaxSize(),
                    state                   = pagerState,
                    userScrollEnabled       = false, // Деактивирано swipe преминаване между табове
                    beyondViewportPageCount = pages.value.items.size,
                    pageContent             = remember(useNativeStyleWebLayout, useMobileMerchantViewsOnWeb) { { index ->
                        pages.value.items[index].instance?.also { page ->
                            when (page) {
                                // Client pages
                                is HomePageViewModel        -> HomePageView(viewModel = page)
                                is DeliveryPageViewModel    -> if (PlatformHelper.isWeb && !useNativeStyleWebLayout) DeliveryPageWebView(page) else DeliveryPageView(page)
                                is FavoritesPageViewModel   -> if (PlatformHelper.isWeb && !useNativeStyleWebLayout) FavoritesPageWebView(page) else FavoritesPageView(page)
                                is ProfilePageViewModel     -> if (PlatformHelper.isWeb && !useNativeStyleWebLayout) ProfilePageWebView(page) else ProfilePageView(page)
                                // Merchant pages
                                is DashboardViewModel       -> if (useNativeStyleWebLayout) DashboardView(page) else DashboardWebView(page)
                                is BagsViewModel            -> if (useMobileMerchantViewsOnWeb || !PlatformHelper.isWeb) BagsView(page) else BagsWebView(page)
                                is MerchantLocationsListViewModel -> if (useMobileMerchantViewsOnWeb || !PlatformHelper.isWeb) MerchantLocationsListView(page) else MerchantLocationsListWebView(page)
                                is MenuViewModel            -> if (useMobileMerchantViewsOnWeb || !PlatformHelper.isWeb) MenuView(page) else MenuWebView(page)
                            }
                        }
                    } }
                )
            }

            val webPortrait = PlatformHelper.isWeb && rememberIsWebPortraitLayout()
            val webLandscape = PlatformHelper.isWeb && !webPortrait

            if (webLandscape) {
                MainWebView(viewModel = viewModel, pagerContent = pagerContent)
            } else {
                // Нативно мобилно или web портрет: pager + долна навигация (еднакъв интерфейс).
                val merchantJwtChrome = Preferences.getString(key = PREFERENCES_MERCHANT_JWT, "")
                val isMerchantChrome = merchantJwtChrome.isNotEmpty()
                val selectedIndex = pages.value.selectedIndex
                val homePageViewModel = pages.value.items.firstOrNull {
                    it.instance is HomePageViewModel
                }?.instance as? HomePageViewModel
                val homeViewMode = subscribeHomeViewModeForWebMap(homePageViewModel)
                val webLocaleKey = WebLocaleComposition.revision

                val mobileShell: @Composable () -> Unit = @Composable {
                    Column(Modifier.fillMaxSize()) {
                        Box(Modifier.fillMaxWidth().weight(1f)) {
                            if (webPortrait && isMerchantChrome) {
                                Box(
                                    modifier = Modifier.fillMaxSize(),
                                    contentAlignment = Alignment.TopCenter
                                ) {
                                    Box(
                                        modifier = Modifier
                                            .width(1080.dp)
                                            .fillMaxHeight()
                                    ) {
                                        pagerContent()
                                    }
                                }
                            } else {
                                pagerContent()
                            }
                        }
                        NavBar(
                            modifier = Modifier
                                .fillMaxWidth()
                                .drawBehind {
                                    drawLine(
                                        color = colors.outline,
                                        start = Offset(0f, 0f),
                                        end = Offset(size.width, 0f),
                                        strokeWidth = 1f
                                    )
                                }
                        )
                    }
                }

                if (PlatformHelper.isWeb) {
                    key(webLocaleKey) {
                        mobileShell()
                    }
                    SideEffect {
                        val shouldShowHomeMap = selectedIndex == PAGE_HOME && homeViewMode == HomeViewMode.MAP
                        if (shouldShowHomeMap) {
                            showWebHomeMapOverlayNow()
                        } else {
                            hideWebHomeMapOverlayNow()
                        }
                    }
                } else {
                    mobileShell()
                }
            }

            StateProgressView(visible = state.value.showInitialDataProgress)
        }
    }
}